import { Multiselect } from 'design-system-web';

export default Multiselect;
